import { render, staticRenderFns } from "./BatchAssignForm.vue?vue&type=template&id=c590a322&scoped=true"
import script from "./BatchAssignForm.vue?vue&type=script&lang=ts"
export * from "./BatchAssignForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c590a322",
  null
  
)

export default component.exports